import { useState, useEffect } from 'react'
export function useCountdown(initialMinutes: number = 15) {
  const [timeLeft, setTimeLeft] = useState(initialMinutes * 60)
  useEffect(() => {
    if (timeLeft <= 0) return
    const intervalId = setInterval(() => {
      setTimeLeft((prev) => prev - 1)
    }, 1000)
    return () => clearInterval(intervalId)
  }, [timeLeft])
  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60
  return {
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
    isExpired: timeLeft <= 0,
  }
}
